import React from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TabPublisher from "./TabPublisher";
import ListPublisher from "./ListPublisher";
import GroupPublisher from "./GroupPublisher";
import ReportPositionsReserver from "./ReportPositionsReserver";
import TitleBar from "../../partials/content/TitleBar";

function AllPublisher() {
  return (
    <>
      <Sidebar activeItem="all-site-publisher" />
      <div className="content-wrapper">
        <TitleBar title="سایت های نمایش دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <TabPublisher />
              <div className="tab-content" id="pills-tabContent">
                <ListPublisher />
                <GroupPublisher />
                <ReportPositionsReserver />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllPublisher;
